import {
  BlockListSectionItem,
  DetailSectionItem,
  Resume,
  Section,
  TemplateId,
} from '@sr/types';
import humanizeUrl from 'humanize-url';
import * as React from 'react';
import urlRegex from 'url-regex';
import Alexander from '../alexander/Alexander';
import Arbutus from '../arbutus/Arbutus';
import Cordova from '../cordova/Cordova';
import Eton from '../eton/Eton';
import Georgia from '../georgia/Georgia';
import Keefer from '../keefer/Keefer';
import Parker from '../parker/Parker';
import Pender from '../pender/Pender';
import SanJuan from '../san-juan/SanJuan';
import Seymore from '../seymore/Seymore';
import Venables from '../venables/Venables';
import Yew from '../yew/Yew';
import { ResumeTheme } from './base-theme';

interface WithTheme {
  theme: (customizations: any) => ResumeTheme;
}

export const getResumeTemplateComponent = (
  template: TemplateId
): React.ComponentType<any> & WithTheme => {
  switch (template) {
    case 'san-juan':
      return SanJuan;
    case 'keefer':
      return Keefer;
    case 'yew':
      return Yew;
    case 'arbutus':
      return Arbutus;
    case 'pender':
      return Pender;
    case 'georgia':
      return Georgia;
    case 'alexander':
      return Alexander;
    case 'eton':
      return Eton;
    case 'seymore':
      return Seymore;
    case 'cordova':
      return Cordova;
    case 'parker':
      return Parker;
    case 'venables':
      return Venables;
    default:
      console.log('Template ID', template);
      throw new Error('Invalid resume template');
  }
};

export const sectionsFromResume = (resume: Resume): Section[] => {
  return (resume.sectionsOrder || []).map(
    (sectionId) => resume.sections[sectionId]
  );
};

export const detailItemsFromSection = (
  section: Section
): DetailSectionItem[] => {
  if (section.type !== 'detail') throw new Error('Expected a DetailSection');
  const items: DetailSectionItem[] = [];
  (section.itemsOrder || []).forEach((id) => {
    const item = section.items && section.items[id];

    if (item && item.type === 'detail') {
      items.push(item);
    }
  });
  return items;
};

export const blockListItemsFromSection = (
  section: Section
): BlockListSectionItem[] => {
  if (section.type !== 'block-list')
    throw new Error('Expected a DetailSection');
  const listItems: BlockListSectionItem[] = [];
  (section.itemsOrder || []).forEach((id) => {
    const item = section.items && section.items[id];

    if (item && item.type === 'block-list') {
      listItems.push(item);
    }
  });
  return listItems;
};

type ValidUrl = {
  originalUrl: string;
  validUrl: string;
  humanizedUrl?: string;
};

export function checkUserEnteredUrl(url: string | undefined): ValidUrl | false {
  if (typeof url !== 'string') return false;

  // Clean the URL of basic errors before checking if valid
  let cleanedUrl = url.trim();
  if (!cleanedUrl.startsWith('http')) {
    cleanedUrl = `http://${cleanedUrl}`;
  }

  const isValidUrl = urlRegex({ exact: true }).test(cleanedUrl);

  if (isValidUrl) {
    let humanizedUrl: string | undefined = undefined;

    // This sometimes throws and isn't essential so wrap in try/catch
    try {
      humanizedUrl = humanizeUrl(cleanedUrl);
    } catch (e) {
      console.error(e);
    }

    return {
      originalUrl: url,
      validUrl: cleanedUrl,
      humanizedUrl,
    };
  } else {
    return false;
  }
}
